import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const COATING_URL = `${POSITION_PROPERTY_URL}/coatings`

const errors = createHandbookResponseErrors('покрытие', 'покрытий')

export const CoatingApi = createNewHandbookApi(COATING_URL, errors)
